import { render, staticRenderFns } from "./CommentsFilter.vue?vue&type=template&id=6e9107fa&scoped=true"
import script from "./CommentsFilter.vue?vue&type=script&lang=js"
export * from "./CommentsFilter.vue?vue&type=script&lang=js"
import style0 from "./CommentsFilter.vue?vue&type=style&index=0&id=6e9107fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9107fa",
  null
  
)

export default component.exports